<template>
  <!-- begin:: Header -->
  <div
    id="kt_header"
    ref="kt_header"
    class="kt-header kt-grid__item d-flex justify-space-between"
    v-bind:class="headerClasses"
  >
    <KTSubheader
    style="position: initial"
    
    v-if="subheaderDisplay"
    v-bind:breadcrumbs="breadcrumbs"
    v-bind:title="pageTitle"
    ></KTSubheader>
    <!-- end:: Header Menu -->
    <KTTopbar></KTTopbar>
  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters } from "vuex";
import KTMenu from "@/assets/js/menu.js";
import KTOffcanvas from "@/assets/js/offcanvas.js";
//import KTHeaderMenu from "@/views/theme/header/HeaderMenu.vue";
//import KTTopbar from "@/views/theme/topbar/Topbar.vue";
import KTTopbar from "@/views/theme/topbar/Topbar2.vue";
//import KTSubheader from "@/views/theme/subheader/Subheader.vue";
import KTSubheader from "@/views/theme/subheader/Subheader2.vue";
export default {
  name: "KTHeader",
  components: {
    //KTHeaderMenu,
    KTTopbar,
    KTSubheader
  },
  mounted() {
    new KTOffcanvas(this.$refs["kt_header_menu_wrapper"], {
      overlay: true,
      baseClass: "kt-header-menu-wrapper",
      closeBy: "kt_header_menu_mobile_close_btn",
      toggleBy: {
        target: "kt_header_mobile_toggler",
        state: "kt-header-mobile__toolbar-toggler--active"
      }
    });

    new KTMenu(this.$refs["kt_header_menu"], {
      submenu: {
        desktop: "dropdown",
        tablet: "accordion",
        mobile: "accordion"
      },
      accordion: {
        // accordion toggle slide speed in milliseconds
        slideSpeed: 200,
        // allow having multiple expanded accordions in the menu
        expandAll: false
      },
      dropdown: {
        timeout: 50
      }
    });
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses", "breadcrumbs", "pageTitle"]),

    /**
     * Check if the header menu is enabled
     * @returns {boolean}
     */
    headerMenuEnabled() {
      return !!this.layoutConfig("header.menu.self.display");
    },

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Get extra classes for header menu based on the options
     * @returns {null|*}
     */
    headerMenuClasses() {
      const classes = this.getClasses("header_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    }
  }
};
</script>
<style lang="scss">
.kt-header{
  justify-content: space-between;
}
#kt_subheader{
    height: 100%;
    -webkit-box-shadow: none;
    box-shadow: none;
}
@media screen and (max-width: 1024px) {
    #kt_subheader{
        display: none;
    }
}
</style>
